(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const sliderSelectors = [
    '.dol-contact__mobile-slider',
    '.stc-track',
    '.dol-trust',
    '.fbq__carousel',
    '.slider.slider--mobile:not(.product__media-list):not(.thumbnail-list)',
    '.slider.slider--tablet:not(.product__media-list):not(.thumbnail-list)',
    '.slider.slider--everywhere:not(.product__media-list):not(.thumbnail-list)'
  ];

  const initialized = new WeakSet();

  const visibleChildren = (slider) => Array.from(slider.children).filter((child) => {
    if (child.matches('script, style')) return false;
    return child.offsetWidth > 0;
  });

  const stepSize = (slider) => {
    const slides = visibleChildren(slider);
    if (slides.length < 2) return 0;
    return slides[1].offsetLeft - slides[0].offsetLeft || slides[0].getBoundingClientRect().width;
  };

  const enhance = (slider) => {
    if (!slider || initialized.has(slider)) return;
    const slides = visibleChildren(slider);
    if (slides.length < 2) return;

    initialized.add(slider);
    slider.classList.add('dol-mobile-slider-ready');

    let pausedUntil = 0;
    const pause = () => {
      pausedUntil = Date.now() + 7000;
    };

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((eventName) => {
      slider.addEventListener(eventName, pause, { passive: true });
    });

    const tick = () => {
      if (!mobileQuery.matches || document.hidden || Date.now() < pausedUntil) return;
      const step = stepSize(slider);
      if (!step) return;
      const isAtEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 16;
      slider.scrollTo({ left: isAtEnd ? 0 : slider.scrollLeft + step, behavior: 'smooth' });
    };

    window.setInterval(tick, 3800);
  };

  const enhanceAll = () => {
    if (!mobileQuery.matches) return;
    document.querySelectorAll(sliderSelectors.join(',')).forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', enhanceAll);
  mobileQuery.addEventListener('change', enhanceAll);
})();
